(function($) {
  var slider1Setting = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    dots: true,
    adaptiveHeight: true,
  }
  $(window).on('load', function () {
    $('.gallery.slider1').slick(slider1Setting);
    $('.gallery.slider2').slick({
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
    });
    $('.gallery.slider3').slick({
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
    });
    initPhotoSwipeFromDOM('.photo-zoom');
    $('.js-photo-zoom').on('click', function(e) {
        var photo = $(this).attr('href');
        $(photo).trigger('click')
        return false;
    });
  });
  var doit;
  $(window).on('resize', function(event) {
    clearTimeout(doit);
    doit = setTimeout(resizedw, 100);
  });
  $(window).on('load', function () {
    resizedw();
  });
  function resizedw(){
    if ($('.sect3 .gallery.slider1.photo-zoom').slick('getSlick')) {
      if ($('.nav-toggle').is(':hidden')) {
        $('.sect3 .gallery.slider1.photo-zoom').slick('unslick');
      } else {
        $('.sect3 .gallery.slider1.photo-zoom').slick(slider1Setting);
      }
    }
  }
})($);